import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import FigureForm from './forms/figureForm';
import FigureList from './lists/figureList';
import FigureGallery from './lists/figureGallery';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {SelectButton} from "primereact/selectbutton";

const listTypes = [
    {label: 'Galéria', value: 'gallery', type: FigureGallery},
    {label: 'Táblázat', value: 'table', type: FigureList}
];

class figureEditor extends React.Component {

    state = {
        listType: 'gallery'
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const ListBox = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const ListType = this.props.listType || listTypes.find((v) => v.value === this.state.listType).type || FigureList;
        return (
            <Fragment>
                <ListBox
                    {...this.props}
                    theme="default"
                    header={"Képek"}
                    actions={<SelectButton value={this.state.listType} options={listTypes}
                                           onChange={(e) => this.setState({listType: e.value || listTypes[0].value})}/>}
                    footer={[
                        <Button key="0" disabled={this.props.isLoading} color="default" onClick={ this.pristineForm }>
                            Új
                        </Button>,
                        <Button key="1" disabled={this.props.isLoading}
                                color="danger"
                                onClick={this.props.deleteForm}>
                            Törlés
                        </Button>
                    ]}
                >
                    <ListType ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </ListBox>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Kép"}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>
                    ]}
                >
                    <FigureForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "figure", WrappedComponent: figureEditor});
